import { Component } from '@angular/core';
import { PATHS } from 'models/bary-paths.model';

@Component({
  selector: 'jhi-my-registered-address',
  templateUrl: './my-registered-addresses.component.html',
})
export class MyRegisteredAddressesComponent {
  steps: Array<{ title: string; url: string }>;
  PATHS = PATHS;
  active = 0;

  constructor() {
    this.steps = [
      { title: 'my-registered-addresses.pickup', url: '/' + PATHS.USER_MY_REGISTERED_ADDRESSES_PICKUP.path },
      { title: 'my-registered-addresses.delivery', url: '/' + PATHS.USER_MY_REGISTERED_ADDRESSES_DELIVERY.path },
    ];
  }
}
